export default __webpack_public_path__ + "scripts/resource/43b6cccf197956dc725d35e40b9e665e.svg";